import { BaseEntity } from "../common/baseEntity";
import { Component } from "../components/component";

export class PermissionScope extends BaseEntity<number> {
    ComponentId: Component;
    Permissions: Array<Permission>;
}

export enum Permission {
    Read = 0,
    Write = 1
}


// WEBPACK FOOTER //
// ./app/objects/groups/permissionScope.ts